<template>
  <div>
    <div class="is-border-right is-border-left is-padding-xsmall is-padding-top-small is-padding-bottom-small">
      <div
        v-if="!openCommentWysi"
        class="vadDiscussion"
        style="cursor: pointer;">
        <div
          v-if="beforeWysiwygText"
          class="is-padding-bottom-xsmall">
          <span
            v-if="hasInfoPicto"
            class="is-padding-right-xsmall has-text-grey ">
            <i class="fas fa-info-circle"></i>
          </span>
          <span
            class="is-size-6 has-text-grey has-text-weight-medium">
            {{ beforeWysiwygText }}
          </span>
        </div>
        <div
          :style="minHeight ? 'min-height: 60px' : 'min-height: 100px'"
          class="vadDiscussion--bulle is-size-6 vadDiscussion--bulle--has-actions is-cut is-padding-left">
          <div
            style="max-height: 350px; overflow: scroll"
            class="content"
            v-if="comment"
            v-html="comment">
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div class="">
              <button
                @click="openWysiwyg"
                class="is-min-height-full">
                <span class="icon is-small"><i class="fal fa-pencil"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="is-border-top columns is-gapless">
        <div
          class="column"
          style="
            max-height: 350px !important;
            overflow: scroll;">
          <wysiwyg-editor
            :light="true"
            :tooltip-top="true"
            :model="comment"
            background-color="has-background-white"
            @change="val => comment = val"
            class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
          </wysiwyg-editor>
        </div>
        <div class="actionsOnRow actionsOnRow--vertical">
          <div class="">
            <button
              type="button"
              :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
              @click="openCommentWysi = false; comment = baseComment">
              <span class="icon is-small"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div>
            <button
              @click="patchComment()"
              type="button"
              class="button"
              :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
              :disabled="(baseComment === comment)">
              <span class="icon is-small">
                <i
                  class="fal fa-save"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomMentionSectionBloc',
  props: {
    content: {
      type: String
    },
    hasInfoPicto: {
      type: Boolean,
      default: false
    },
    beforeWysiwygText: {
      type: String,
      default: null
    },
    minHeight: {
      type: Boolean
    }
  },
  data () {
    return {
      comment: null,
      openCommentWysi: false,
      baseComment: null,
      openComment: false
    }
  },
  created () {
    this.baseComment = this.content
    this.comment = this.content
  },
  methods: {
    openWysiwyg () {
      this.openCommentWysi = true
    },
    async patchComment () {
      this.$emit('updateComment', this.comment)
      this.openCommentWysi = !this.comment
      this.baseComment = this.comment
    }
  }
}
</script>

<style>
  .content p {
    margin-bottom: 0 !important;
  }
</style>
